<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column label="wbo.account-type.edit.field-set.security">
                <wbo-checkbox-edit-control formControlName="mgtOnly" [(ngModel)]="model.data.mgtOnly">
                </wbo-checkbox-edit-control>
                <wbo-checkbox-edit-control formControlName="authRequired" [(ngModel)]="model.data.authRequired">
                </wbo-checkbox-edit-control>
                <wbo-checkbox-edit-control formControlName="multipleContacts" [(ngModel)]="model.data.multipleContacts" [readonly]="isMultipleContactsReadonly">
                </wbo-checkbox-edit-control>
            </fui-column>
            <fui-column label="wbo.account-type.edit.field-set.paymentOptions">
                <wbo-checkbox-edit-control formControlName="allowAccountRefunds" [(ngModel)]="model.data.allowAccountRefunds">
                </wbo-checkbox-edit-control>
                <wbo-checkbox-edit-control formControlName="splitTender" [(ngModel)]="model.data.splitTender" [readonly]="isSplitTenderReadonly">
                </wbo-checkbox-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column label="wbo.account-type.edit.field-set.printingOptions">
                <wbo-text-edit-control formControlName="invoicePrintCount"
                                       [(ngModel)]="model.data.invoicePrintCount" [readonly]="isInvoicePrintCountReadonly"></wbo-text-edit-control>
                <wbo-checkbox-edit-control formControlName="printBalance" [(ngModel)]="model.data.printBalance">
                </wbo-checkbox-edit-control>
                <wbo-checkbox-edit-control formControlName="printBalanceOnAccountPayment" [(ngModel)]="model.data.printBalanceOnAccountPayment">
                </wbo-checkbox-edit-control>
            </fui-column>
            <fui-column label="wbo.account-type.edit.field-set.pointOfSaleAccess">
                <wbo-single-select-edit-control formControlName="displayType" [(ngModel)]="model.data.displayType" [allowClearSelectionOption]="false">
                    <wbo-select-options>
                        <wbo-select-option [value]="0" label="wbo.account-type.edit.field.buttons.label">
                        </wbo-select-option>
                        <wbo-select-option [value]="1" label="wbo.account-type.edit.field.tabulated.label">
                        </wbo-select-option>
                        <wbo-select-option [value]="2" label="wbo.account-type.edit.field.swipeOnly.label">
                        </wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-edit-control>
                <wbo-checkbox-edit-control formControlName="searchable" [(ngModel)]="model.data.searchable">
                </wbo-checkbox-edit-control>
                <wbo-checkbox-edit-control formControlName="balanceTender" [(ngModel)]="model.data.balanceTender">
                </wbo-checkbox-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
